import {PageStandard} from "../utils/PageStandard";
import {
    Button,
    Card,
    FormControl,
    FormLabel,
    IconButton,
    Input,
    Modal,
    ModalClose,
    Sheet,
    Stack,
    Typography
} from "@mui/joy";
import React, {useEffect, useState} from "react";
import {CategoriaModel, ServizioModel} from "../utils/Model";
import {DeleteForever, Edit, FileDownload} from "@mui/icons-material";
import EmojiPicker from "emoji-picker-react";
import {addCategory, deleteCategory, editCategoria, getCategories} from "../utils/ViewModel";
import {downloadCSV, hasChanges} from "../utils/Utils";
import moment from "moment";


export function Categorie() {

    const [modalAddCategoria, setModalAddCategoria] = useState(false);
    const initialDataNewCategoria = {
        title: "",
        icon: "",
    }
    const [newCategoria, setNewCategoria] = useState(initialDataNewCategoria)
    const [categorie, setCategorie] = useState<CategoriaModel[]>([])
    useEffect(() => {
        loadData()
    }, [])

    function loadData() {
        getCategories().then(data => {
            setCategorie(data);
        });
    }

    return (
        <PageStandard title="Categorie" sidebarVisible={true} headerEnd={
            <Stack direction="row" spacing={2}>
                <Button onClick={() => setModalAddCategoria(true)}>Aggiungi categoria</Button>
                <Button startDecorator={<FileDownload />}
                        onClick={() => {
                            downloadCSV<CategoriaModel>({
                                data: categorie,
                                fields: ["id", "title", "icon"],
                                filename: `oasi-categorie-${moment().format("YYYY-MM-DD")}.csv`,
                            })
                        }}
                >
                    Esporta tutti in CSV
                </Button>
            </Stack>
        }>
            <Stack direction="column" spacing={2} pb={5}>
                {
                    categorie?.length > 0 ?
                        categorie.map(c => <ItemCategoria key={c.id} data={c} loadData={loadData} />)
                        :
                        <Typography level="body-md">Non sono presenti categorie</Typography>
                }
            </Stack>

            <Modal
                open={modalAddCategoria}
                onClose={() => setModalAddCategoria(false)}
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <Sheet
                    variant="outlined"
                    sx={{ minWidth: 500, borderRadius: 'md', p: 3, boxShadow: 'lg' }}
                >
                    <ModalClose variant="plain" sx={{ m: 1 }} />
                    <Typography component="h2" level="h4"
                                sx={{ fontWeight: 'lg', mb: 1 }}
                    >
                        {newCategoria.icon !== "" && newCategoria.icon} Aggiungi categoria
                    </Typography>
                    <Stack direction="column" spacing={2}>
                        <FormControl>
                            <FormLabel>Icona categoria{newCategoria.icon !== "" && ` - Attuale: ${newCategoria.icon}`}</FormLabel>
                            <EmojiPicker
                                onEmojiClick={emoji => setNewCategoria({...newCategoria, icon: emoji.emoji})}
                                skinTonesDisabled
                                width="100%"
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Titolo categoria</FormLabel>
                            <Input type="text"
                                   value={newCategoria.title}
                                   onChange={(e) => setNewCategoria({...newCategoria, title: e.target.value})}
                                   placeholder="Dormire"
                            />
                        </FormControl>
                        <Button fullWidth
                                disabled={newCategoria.title.trim().length === 0 || newCategoria.icon.trim().length === 0}
                                onClick={() => {
                                    addCategory(newCategoria.title.trim(), newCategoria.icon.trim())
                                        .then(() => {
                                            loadData()
                                            setNewCategoria(initialDataNewCategoria)
                                            setModalAddCategoria(false)
                                        })
                                }}
                        >
                            Aggiungi
                        </Button>
                    </Stack>
                </Sheet>
            </Modal>
        </PageStandard>
    )
}

function ItemCategoria(props: {data: CategoriaModel, loadData: () => void}) {
    const loadData = props.loadData;
    const defaultdata = props.data

    const [data, setData] = useState<CategoriaModel>(props.data);
    const [modalEdit, setModalEdit] = useState(false)

    return (
        <Card>
            <Stack direction="row" spacing={2} justifyContent="space-between">
                <Stack direction="row" spacing={2} alignItems="center">
                    <Typography level="h2">{defaultdata.icon}</Typography>
                    <Typography level="title-lg" fontWeight="bold">{defaultdata.title}</Typography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <IconButton color="primary" variant="outlined"
                                onClick={() => {
                                    setModalEdit(true)
                                }}
                    >
                        <Edit />
                    </IconButton>
                    <IconButton color="danger" variant="outlined"
                                onClick={() => {
                                    if(window.confirm(`Eliminare definitivamente la categoria ${defaultdata.icon} ${defaultdata.title} ?`)) {
                                        deleteCategory(defaultdata.id)
                                            .then(() => {
                                                loadData()
                                            })
                                    }
                                }}
                    >
                        <DeleteForever />
                    </IconButton>
                </Stack>
            </Stack>

            <Modal
                open={modalEdit}
                onClose={() => cancelModal()}
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <Sheet
                    variant="outlined"
                    sx={{ minWidth: 500, borderRadius: 'md', p: 3, boxShadow: 'lg' }}
                >
                    <ModalClose variant="plain" sx={{ m: 1 }} />
                    <Typography component="h2" level="h4"
                                sx={{ fontWeight: 'lg', mb: 1 }}
                    >
                        {data.icon !== "" && data.icon} Modifica categoria
                    </Typography>
                    <Typography level="body-sm" sx={{fontFamily:"monospace", mb:2}}>
                        ID: {defaultdata.id}
                    </Typography>
                    <Stack direction="column" spacing={2}>
                        <FormControl>
                            <FormLabel>Icona categoria{data.icon !== "" && ` - Attuale: ${data.icon}`}</FormLabel>
                            <EmojiPicker
                                onEmojiClick={emoji => setData({...data, icon: emoji.emoji})}
                                skinTonesDisabled
                                width="100%"
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Titolo categoria</FormLabel>
                            <Input type="text"
                                   value={data.title}
                                   onChange={(e) => setData({...data, title: e.target.value})}
                                   placeholder="Dormire"
                            />
                        </FormControl>
                        <Stack direction="row" spacing={2}>
                            <Button fullWidth
                                    variant="outlined"
                                    color="neutral"
                                    onClick={() => cancelModal()}
                            >
                                Annulla
                            </Button>
                            <Button fullWidth
                                    disabled={data.title.trim().length === 0 || data.icon.trim().length === 0 || !hasChanges(props.data, data)}
                                    onClick={() => {
                                        editCategoria(data)
                                            .then(() => {
                                                loadData()
                                                setModalEdit(false)
                                            })
                                    }}
                            >
                                Modifica
                            </Button>
                        </Stack>
                    </Stack>
                </Sheet>
            </Modal>
        </Card>
    )

    function cancelModal() {
        setModalEdit(false)
        setData(defaultdata)
    }
}